import { MaintenanceDataTable } from '@/features/maintenance-data/MaintenanceDataTable';

export const MaintenanceDataPage = () => {
    return <MaintenanceDataTable />;
};
